// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.top-heading img {
  max-width: 300px;
}

.launch-is {
  margin: 30px;
  margin-left: 0px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.launch-is button {
  padding: 8px 20px;
}

.shaded-part {
  text-align: center;
}
.shaded-part span {
  font-size: 20px;
  font-weight: 100;
}

.content-part p,
.content-part ul,
.content-part ol {
  font-size: 18px;
  font-family: "Museo-100";
}
.content-part ol span {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.content-part h3 {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}

.tips-success__inner {
  width: 50%;
  display: inline-grid;
}

::ng-deep#page-wrapper {
  padding-bottom: 60px;
}

.topnav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 20px 0 30px;
}

.ch-intro {
  max-width: 960px;
  width: 100%;
  margin: 0 auto 20px;
  background-color: #e7e7e7;
  padding: 30px 60px;
  --family-7: "Museo-700";
  --family-3: "Museo-300";
  --family-1: "Museo-100";
}
.ch-intro--wdpd {
  max-width: 1000px;
  padding: 60px;
}
@media only screen and (max-width: 991px) {
  .ch-intro--wdpd {
    padding: 20px;
  }
}
.ch-intro .shaded-part {
  padding: 30px 0;
}
.ch-intro .shaded-part h3 {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 24px;
  line-height: 30px;
  margin: 0px 0 4px;
}
.ch-intro .shaded-part h3 + span {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.ch-intro__inner {
  max-width: 680px;
  width: 100%;
}
.ch-intro__head {
  max-width: 600px;
  margin: 0 auto;
}
.ch-intro__txt p a {
  color: #979797;
  text-decoration: underline;
}
.ch-intro__top {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}
.ch-intro__topon strong {
  width: 100%;
  font-family: var(--family-7);
  color: #686b6d;
  font-size: 60px;
  display: block;
  margin-bottom: 5px;
}
@media only screen and (max-width: 991px) {
  .ch-intro__topon strong {
    font-size: 44px;
  }
}
@media only screen and (max-width: 767px) {
  .ch-intro__topon strong {
    font-size: 24px;
  }
}
.ch-intro__topon img {
  max-width: 190px;
}
@media only screen and (max-width: 767px) {
  .ch-intro__topon img {
    max-width: 160px;
  }
}
.ch-intro__topon h3 {
  font-size: 40px;
  font-weight: 700;
  max-width: 596px;
  line-height: 1.1;
  font-family: var(--family-1);
  text-align: right;
  color: #979797;
  margin-left: auto;
}
@media only screen and (max-width: 991px) {
  .ch-intro__topon h3 {
    font-size: 24px;
  }
}
@media only screen and (max-width: 767px) {
  .ch-intro__topon h3 {
    font-size: 20px;
  }
}
.ch-intro__topon sub {
  font-size: 12px;
}
.ch-intro__topleft {
  width: 390px;
}
@media only screen and (max-width: 991px) {
  .ch-intro__topleft {
    width: 100%;
  }
}
.ch-intro__topleft h1 {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  margin-top: 0;
  font-size: 60px;
}
.ch-intro__topleft h1 span {
  position: relative;
}
.ch-intro__topleft h1 span sup {
  border: 1px solid #676a6c;
  border-radius: 50%;
  width: 21px;
  height: 21px;
  font-size: 15px;
  display: inline-block;
  line-height: 1;
  text-align: center;
  padding: 3px;
  position: absolute;
  top: 0;
  right: -22px;
}
.ch-intro__topleft h1 small {
  font-size: 20px;
  margin-left: 20px;
}
.ch-intro__topright {
  width: calc(100% - 391px);
  padding-top: 16px;
  font-family: "Museo-700";
}
@media only screen and (max-width: 991px) {
  .ch-intro__topright {
    width: 100%;
  }
}
@media only screen and (max-width: 991px) {
  .ch-intro__bottom {
    margin-top: 30px;
  }
}
.ch-intro__bottom--ol {
  display: flex;
  flex-wrap: wrap;
}
.ch-intro__bottom--ol > div {
  width: 50%;
}
@media only screen and (max-width: 767px) {
  .ch-intro__bottom--ol > div {
    width: 100%;
  }
}
.ch-intro__bottom--ol .intro-content__left {
  padding-right: 15px;
  font-size: 18px;
  color: #696c6e;
  max-width: 250px;
  line-height: 1.4;
}
.ch-intro__bottom--ol .intro-content__left h3 {
  padding-bottom: 10px;
}
.ch-intro__bottom--ol .intro-content__left a.f-btn {
  color: #fff;
  text-decoration: none;
  font-family: var(--family-7);
  margin: 76px 0px 10px;
  padding: 13px 40px;
  width: 100%;
  border-radius: 0;
  background-color: #73bf38;
}
@media only screen and (max-width: 767px) {
  .ch-intro__bottom--ol .intro-content__left a.f-btn {
    padding: 10px 20px;
    margin: 20px 0;
  }
}
.ch-intro__bottom--ol .intro-content__left a.f-btn:hover {
  background-color: #4cae4c;
  border-color: #4cae4c;
}
.ch-intro__bottom--ol .intro-content__left p {
  font-size: 18px;
  font-family: var(--family-1);
  margin-top: 25px;
}
.ch-intro__bottom--ol .intro-content__left p a {
  text-decoration: underline;
  color: #696c6e;
  display: block;
}
@media only screen and (max-width: 767px) {
  .ch-intro__bottom--ol .intro-content__left {
    order: 2;
    padding-right: 0;
  }
}
.ch-intro__bottom--ol .intro-content__right img {
  margin-top: -20px;
  margin-left: -22px;
}
@media only screen and (max-width: 991px) {
  .ch-intro__bottom--ol .intro-content__right img {
    margin-top: 0;
    margin-left: 0;
  }
}
@media only screen and (max-width: 767px) {
  .ch-intro__bottom--ol .intro-content__right {
    margin-bottom: 20px;
  }
}
.ch-intro__bottom h3 {
  margin: 0 0 10px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 24px;
}
@media only screen and (max-width: 991px) {
  .ch-intro__bottom h3 {
    font-size: 20px;
  }
}
.ch-intro__bottom p {
  font-size: 15px;
  margin: 0 0 10px;
  font-family: "Museo-300" !important;
  font-weight: normal !important;
}
.ch-intro__bottom h4 {
  margin-top: 20px;
  font-size: 18px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.ch-intro__bottom ol,
.ch-intro__bottom ul {
  padding: 0 0 0 20px;
  margin: 0;
}
.ch-intro__bottom ol li,
.ch-intro__bottom ul li {
  font-size: 15px;
  font-family: "Museo-300" !important;
  font-weight: normal !important;
}
.ch-intro__bottom ol li strong,
.ch-intro__bottom ul li strong {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.ch-intro__bottom ol li + li,
.ch-intro__bottom ul li + li {
  margin-top: 5px;
}

.mainnav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 30px 0 40px;
}
.mainnav.mainnav--bottom {
  margin: 80px 0 70px;
}
.mainnav.mainnav--bottom ul li a {
  padding: 12px 30px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
.mainnav ul {
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #CFDBE2;
  border-radius: 6px;
  overflow: hidden;
}
.mainnav ul li {
  list-style: none;
  transition: none;
}
.mainnav ul li + li {
  border-left: 1px solid #CFDBE2;
}
.mainnav ul li.active a {
  background-color: rgb(0, 173, 208);
  color: #fff;
  opacity: 1;
}
.mainnav ul li.clarify a {
  background-color: rgb(0, 173, 208);
  color: #fff;
  opacity: 1;
}
.mainnav ul li.ideate a {
  background-color: rgb(255, 121, 0);
  color: #fff;
  opacity: 1;
}
.mainnav ul li.develop a {
  background-color: rgb(105, 190, 40);
  color: #fff;
  opacity: 1;
}
.mainnav ul li.implement a {
  background-color: rgb(245, 67, 89);
  color: #fff;
  opacity: 1;
}
.mainnav ul li.previous a {
  opacity: 1;
}
.mainnav ul li.previous a:hover > i {
  left: -5px;
}
.mainnav ul li.next a {
  color: rgb(255, 121, 0);
  opacity: 1;
}
.mainnav ul li.next a:hover > i {
  left: 5px;
}
.mainnav ul li a {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 18px;
  color: #676a6c;
  opacity: 0.47;
  padding: 20px 30px;
  display: inline-block;
  transition: all ease 0.3s;
}
.mainnav ul li a i {
  position: relative;
  font-size: 1.1em;
  left: 0;
  transition: all ease 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/challenges/introduction-challenge/introduction-challenge.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5WA;EACE,gBAAA;AA+WF;;AA5WA;EAEE,YAAA;EACA,gBAAA;EDwHA,mCAAA;EACA,8BAAA;ACuPF;AA7WE;EACE,iBAAA;AA+WJ;;AA3WA;EACE,kBAAA;AA8WF;AA5WE;EACE,eAAA;EACA,gBAAA;AA8WJ;;AAxWE;;;EAGE,eAAA;EACA,wBAAA;AA2WJ;AAvWI;ED6FF,mCAAA;EACA,8BAAA;AC6QF;AAtWE;EDwFA,mCAAA;EACA,8BAAA;ACiRF;;AArWA;EACE,UAAA;EACA,oBAAA;AAwWF;;AArWA;EACE,oBAAA;AAwWF;;AArWA;EAGE,aAAA;EAEA,eAAA;EAGA,uBAAA;EACA,mBAAA;AAwWF;;AArWA;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;AAwWF;AAtWE;EACE,iBAAA;EACA,aAAA;AAwWJ;AAtWI;EAJF;IAKI,aAAA;EAyWJ;AACF;AAtWE;EACE,eAAA;AAwWJ;AAtWI;EDwCF,mCAAA;EACA,8BAAA;ECvCI,eAAA;EACA,iBAAA;EACA,iBAAA;AAyWN;AAvWM;EDkCJ,mCAAA;EACA,8BAAA;ACwUF;AArWE;EACE,gBAAA;EACA,WAAA;AAuWJ;AApWE;EACE,gBAAA;EACA,cAAA;AAsWJ;AAhWM;EACE,cAAA;EACA,0BAAA;AAkWR;AA7VE;EArJA,aAAA;EAEA,eAAA;EAqJE,sBAAA;AAmWJ;AAhWM;EACE,WAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAkWR;AAhWQ;EARF;IASI,eAAA;EAmWR;AACF;AAjWQ;EAZF;IAaI,eAAA;EAoWR;AACF;AAjWM;EACE,gBAAA;AAmWR;AAjWQ;EAHF;IAII,gBAAA;EAoWR;AACF;AAjWM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAmWR;AAjWQ;EAVF;IAWI,eAAA;EAoWR;AACF;AAlWQ;EAdF;IAeI,eAAA;EAqWR;AACF;AAlWM;EACE,eAAA;AAoWR;AAhWI;EACE,YAAA;AAkWN;AAhWM;EAHF;IAII,WAAA;EAmWN;AACF;AAjWM;EDrDJ,mCAAA;EACA,8BAAA;ECsDM,aAAA;EACA,eAAA;AAoWR;AAlWQ;EACE,kBAAA;AAoWV;AAlWU;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;AAoWZ;AAhWQ;EACE,eAAA;EACA,iBAAA;AAkWV;AA7VI;EACE,yBAAA;EACA,iBAAA;EACA,wBAAA;AA+VN;AA7VM;EALF;IAMI,WAAA;EAgWN;AACF;AA1VI;EADF;IAEI,gBAAA;EA6VJ;AACF;AA3VI;EACE,aAAA;EACA,eAAA;AA6VN;AA3VM;EACE,UAAA;AA6VR;AA3VQ;EAHF;IAII,WAAA;EA8VR;AACF;AAzVQ;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA2VV;AAzVU;EACE,oBAAA;AA2VZ;AAxVU;EACE,WAAA;EACA,qBAAA;EACA,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;AA0VZ;AAxVY;EAVF;IAWI,kBAAA;IACA,cAAA;EA2VZ;AACF;AAzVY;EACE,yBAAA;EACA,qBAAA;AA2Vd;AAvVU;EACE,eAAA;EACA,4BAAA;EACA,gBAAA;AAyVZ;AAvVY;EACE,0BAAA;EACA,cAAA;EACA,cAAA;AAyVd;AArVU;EA5CF;IA6CI,QAAA;IACA,gBAAA;EAwVV;AACF;AAnVU;EACE,iBAAA;EACA,kBAAA;AAqVZ;AAnVY;EAJF;IAKI,aAAA;IACA,cAAA;EAsVZ;AACF;AAnVU;EAZF;IAaI,mBAAA;EAsVV;AACF;AAjVI;EACE,gBAAA;EDzLJ,mCAAA;EACA,8BAAA;EC0LI,eAAA;AAoVN;AAlVM;EALF;IAMI,eAAA;EAqVN;AACF;AAlVI;EACE,eAAA;EACA,gBAAA;ED/LJ,mCAAA;EACA,8BAAA;ACohBF;AAlVI;EACE,gBAAA;EACA,eAAA;ED1MJ,mCAAA;EACA,8BAAA;AC+hBF;AAlVI;;EAEE,mBAAA;EACA,SAAA;AAoVN;AAlVM;;EACE,eAAA;ED/MN,mCAAA;EACA,8BAAA;ACqiBF;AApVQ;;EDvNN,mCAAA;EACA,8BAAA;AC+iBF;AArVQ;;EACE,eAAA;AAwVV;;AAjVA;EAhYE,aAAA;EAEA,eAAA;EAMA,uBAAA;EA2XA,mBAAA;AA0VF;AAxVE;EACE,mBAAA;AA0VJ;AAtVQ;EACE,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AAwVV;AAlVE;EACE,UAAA;EACA,SAAA;EAtZF,aAAA;EAEA,eAAA;EAsZE,yBAAA;EACA,kBAAA;EACA,gBAAA;AAwVJ;AAtVI;EACE,gBAAA;EAlYJ,gBAAA;AA6tBF;AAxVM;EACE,8BAAA;AA0VR;AAtVQ;EACE,kCDrZM;ECsZN,WAAA;EACA,UAAA;AAwVV;AApVM;EACE,kCD5ZQ;EC6ZR,WAAA;EACA,UAAA;AAsVR;AAnVM;EACE,kCDjaO;ECkaP,WAAA;EACA,UAAA;AAqVR;AAlVM;EACE,mCDtaQ;ECuaR,WAAA;EACA,UAAA;AAoVR;AAjVM;EACE,kCD3aU;EC4aV,WAAA;EACA,UAAA;AAmVR;AAhVM;EACE,UAAA;AAkVR;AAhVQ;EACE,UAAA;AAkVV;AA9UM;EACE,uBD3bO;EC4bP,UAAA;AAgVR;AA9UQ;EACE,SAAA;AAgVV;AA5UM;EDxTJ,mCAAA;EACA,8BAAA;ECyTM,eAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EAtcN,yBAAA;AAwxBF;AA/UQ;EACE,kBAAA;EACA,gBAAA;EACA,OAAA;EA5cR,yBAAA;AAgyBF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n@mixin fflex() {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n@mixin fflex-jcc() {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n@mixin fflex-aic() {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n\n@mixin transition-slow() {\n  -webkit-transition: all ease 0.3s;\n  -o-transition: all ease 0.3s;\n  transition: all ease 0.3s;\n}\n\n@mixin transition-none() {\n  -webkit-transition: none;\n  -o-transition: none;\n  transition: none;\n}\n\n.top-heading img {\n  max-width: 300px;\n}\n\n.launch-is {\n  // text-align: center;\n  margin: 30px;\n  margin-left: 0px;\n  @include headingfont();\n\n  button {\n    padding: 8px 20px;\n  }\n}\n\n.shaded-part {\n  text-align: center;\n\n  span {\n    font-size: 20px;\n    font-weight: 100;\n  }\n}\n\n.content-part {\n\n  p,\n  ul,\n  ol {\n    font-size: 18px;\n    font-family: \"Museo-100\"\n  }\n\n  ol {\n    span {\n      @include headingfont();\n    }\n  }\n\n  h3 {\n    @include headingfont();\n  }\n}\n\n.tips-success__inner {\n  width: 50%;\n  display: inline-grid;\n}\n\n::ng-deep#page-wrapper {\n  padding-bottom: 60px;\n}\n\n.topnav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin: 20px 0 30px;\n}\n\n.ch-intro {\n  max-width: 960px;\n  width: 100%;\n  margin: 0 auto 20px;\n  background-color: #e7e7e7;\n  padding: 30px 60px;\n  --family-7: \"Museo-700\";\n  --family-3: \"Museo-300\";\n  --family-1: \"Museo-100\";\n\n  &--wdpd {\n    max-width: 1000px;\n    padding: 60px;\n\n    @media #{$tablet} {\n      padding: 20px;\n    }\n  }\n\n  .shaded-part {\n    padding: 30px 0;\n\n    h3 {\n      @include headingfont();\n      font-size: 24px;\n      line-height: 30px;\n      margin: 0px 0 4px;\n\n      &+span {\n        @include headingfont();\n      }\n    }\n  }\n\n  &__inner {\n    max-width: 680px;\n    width: 100%;\n  }\n\n  &__head {\n    max-width: 600px;\n    margin: 0 auto;\n  }\n\n  &__txt {\n\n    p {\n      a {\n        color: #979797;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  &__top {\n    @include fflex();\n    flex-direction: column;\n\n    &on {\n      strong {\n        width: 100%;\n        font-family: var(--family-7);\n        color: #686b6d;\n        font-size: 60px;\n        display: block;\n        margin-bottom: 5px;\n\n        @media #{$tablet} {\n          font-size: 44px;\n        }\n\n        @media #{$mobile} {\n          font-size: 24px;\n        }\n      }\n\n      img {\n        max-width: 190px;\n\n        @media #{$mobile} {\n          max-width: 160px;\n        }\n      }\n\n      h3 {\n        font-size: 40px;\n        font-weight: 700;\n        max-width: 596px;\n        line-height: 1.1;\n        font-family: var(--family-1);\n        text-align: right;\n        color: #979797;\n        margin-left: auto;\n\n        @media #{$tablet} {\n          font-size: 24px;\n        }\n\n        @media #{$mobile} {\n          font-size: 20px;\n        }\n      }\n\n      sub {\n        font-size: 12px;\n      }\n    }\n\n    &left {\n      width: 390px;\n\n      @media only screen and (max-width: 991px) {\n        width: 100%;\n      }\n\n      h1 {\n        @include headingfont();\n        margin-top: 0;\n        font-size: 60px;\n\n        span {\n          position: relative;\n\n          sup {\n            border: 1px solid #676a6c;\n            border-radius: 50%;\n            width: 21px;\n            height: 21px;\n            font-size: 15px;\n            display: inline-block;\n            line-height: 1;\n            text-align: center;\n            padding: 3px;\n            position: absolute;\n            top: 0;\n            right: -22px;\n          }\n        }\n\n        small {\n          font-size: 20px;\n          margin-left: 20px;\n        }\n      }\n    }\n\n    &right {\n      width: calc(100% - 391px);\n      padding-top: 16px;\n      font-family: 'Museo-700';\n\n      @media only screen and (max-width: 991px) {\n        width: 100%;\n      }\n    }\n\n  }\n\n  &__bottom {\n    @media only screen and (max-width: 991px) {\n      margin-top: 30px;\n    }\n\n    &--ol {\n      display: flex;\n      flex-wrap: wrap;\n\n      &>div {\n        width: 50%;\n\n        @media #{$mobile} {\n          width: 100%;\n        }\n      }\n\n      .intro-content {\n\n        &__left {\n          padding-right: 15px;\n          font-size: 18px;\n          color: #696c6e;\n          max-width: 250px;\n          line-height: 1.4;\n\n          h3 {\n            padding-bottom: 10px;\n          }\n\n          a.f-btn {\n            color: #fff;\n            text-decoration: none;\n            font-family: var(--family-7);\n            margin: 76px 0px 10px;\n            padding: 13px 40px;\n            width: 100%;\n            border-radius: 0;\n            background-color: #73bf38;\n\n            @media #{$mobile} {\n              padding: 10px 20px;\n              margin: 20px 0;\n            }\n\n            &:hover {\n              background-color: #4cae4c;\n              border-color: #4cae4c;\n            }\n          }\n\n          p {\n            font-size: 18px;\n            font-family: var(--family-1);\n            margin-top: 25px;\n\n            a {\n              text-decoration: underline;\n              color: #696c6e;\n              display: block;\n            }\n          }\n\n          @media #{$mobile} {\n            order: 2;\n            padding-right: 0;\n          }\n        }\n\n        &__right {\n\n          img {\n            margin-top: -20px;\n            margin-left: -22px;\n\n            @media #{$tablet} {\n              margin-top: 0;\n              margin-left: 0;\n            }\n          }\n\n          @media #{$mobile} {\n            margin-bottom: 20px;\n          }\n        }\n      }\n    }\n\n    h3 {\n      margin: 0 0 10px;\n      @include headingfont();\n      font-size: 24px;\n\n      @media #{$tablet} {\n        font-size: 20px;\n      }\n    }\n\n    p {\n      font-size: 15px;\n      margin: 0 0 10px;\n      @include contentfont();\n    }\n\n    h4 {\n      margin-top: 20px;\n      font-size: 18px;\n      @include headingfont();\n    }\n\n    ol,\n    ul {\n      padding: 0 0 0 20px;\n      margin: 0;\n\n      li {\n        font-size: 15px;\n        @include contentfont();\n\n        strong {\n          @include headingfont();\n        }\n\n        &+li {\n          margin-top: 5px;\n        }\n      }\n    }\n  }\n}\n\n.mainnav {\n  @include fflex();\n  @include fflex-jcc();\n  margin: 30px 0 40px;\n\n  &.mainnav--bottom {\n    margin: 80px 0 70px;\n\n    ul {\n      li {\n        a {\n          padding: 12px 30px;\n          font-family: 'Open Sans', sans-serif;\n          font-weight: 700;\n          font-size: 16px;\n        }\n      }\n    }\n  }\n\n  ul {\n    padding: 0;\n    margin: 0;\n    @include fflex();\n    border: 1px solid #CFDBE2;\n    border-radius: 6px;\n    overflow: hidden;\n\n    li {\n      list-style: none;\n      @include transition-none();\n\n      &+li {\n        border-left: 1px solid #CFDBE2;\n      }\n\n      &.active {\n        a {\n          background-color: $clarify-color;\n          color: #fff;\n          opacity: 1;\n        }\n      }\n\n      &.clarify a {\n        background-color: $clarify-color;\n        color: #fff;\n        opacity: 1;\n      }\n\n      &.ideate a {\n        background-color: $ideate-color;\n        color: #fff;\n        opacity: 1;\n      }\n\n      &.develop a {\n        background-color: $develop-color;\n        color: #fff;\n        opacity: 1;\n      }\n\n      &.implement a {\n        background-color: $implement-color;\n        color: #fff;\n        opacity: 1;\n      }\n\n      &.previous a {\n        opacity: 1;\n\n        &:hover>i {\n          left: -5px;\n        }\n      }\n\n      &.next a {\n        color: $ideate-color;\n        opacity: 1;\n\n        &:hover>i {\n          left: 5px;\n        }\n      }\n\n      a {\n        @include headingfont();\n        font-size: 18px;\n        color: #676a6c;\n        opacity: 0.47;\n        padding: 20px 30px;\n        display: inline-block;\n        @include transition-slow();\n\n        i {\n          position: relative;\n          font-size: 1.1em;\n          left: 0;\n          @include transition-slow();\n        }\n      }\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
